import { DefaultModalComponents } from '../../../../../components/ProjectModal/utils';
import styled from 'styled-components';
import AppCSS from '../../../../../utils/styled';

export const Components = {
  ...DefaultModalComponents,
  ModalContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    padding-top: 8px;
  `,
  ModalBodyContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  ModalTitle: styled.span`
    ${AppCSS.fonts.h4};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  FieldWrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.radiuses.small};
  `,
  FieldLabel: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  FieldText: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  ModalButtonsContainer: styled.div`
    width: 100%;
    gap: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  PrimaryButton: styled(AppCSS.buttonStyles.PrimaryButtonStyle)``,
  TertiaryButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)``,
  Subtitle: styled.span`
    ${AppCSS.fonts.label10Regular};
    color: ${AppCSS.colors.blues.middle};
  `,
  ModalContentWrapper: styled.div`
    gap: 8px;
    display: flex;
    flex-direction: column;
  `,
};
